// app.js
"use strict";

import angular from "angular";
import "angular-i18n/angular-locale_es-es";
import "@uirouter/angularjs";
import "oclazyload";
import "bootstrap/dist/css/bootstrap.min.css";
import "./core/core.less";

import { appRouting } from "./app.routing";
import { scroll } from "./app.scrollToTop.run";
import { COOKIES_MODULE } from "./components/cookies/cookies.module";

import { configHttp } from "./core/config.http";



const SWENO_ENERGIA =  angular
    .module("sweno", [
        "ui.router",
        "oc.lazyLoad",
        COOKIES_MODULE
    ])
    .config(appRouting)
    .run(scroll)
    .config(configHttp)
    ;

export { SWENO_ENERGIA };
